import OAuthClient from "@/helpers/oauth/OAuthClient";
import { getAccountDomain } from '../../constants/urls'
import { config } from '../../env'

export default new OAuthClient({
    redirectUrl: window.location.origin + '/oauth',
    authorizeUrl: () => getAccountDomain() + '/oauth/authorize',
    logoutUrl: () => getAccountDomain() + '/api/logout',
    tokenUrl: () => getAccountDomain() + '/oauth/token',
    clientId: () => config('APP_CLIENT_ID'),
    scope: ['*']
})
